var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leftTop"},[_c('div',{staticClass:"scrooList"},[_c('div',{staticClass:"filterBox"}),_c('p',{staticClass:"title"},[_vm._v("儿童数据统计")]),_c('div',{staticStyle:{"width":"420px","height":"400px"},attrs:{"id":"pieCharts"}})])])
}]

export { render, staticRenderFns }